export default __webpack_public_path__ + "static/media/logo-wihtout-label.62e329df.svg";